import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import { MetaText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./ProductPromotionMarker.css";
var styles = { "percentageMarker": "de71ab", "promotionMarker": "c0b00a", "legalTextConatiner": "d47843", "toolTipText": "ce7363" };
const ProductPromotionMarker = ({ legalText, showPriceMarker, promotionalMarkerText, redPrice, discountPercentage, }) => {
    const formatedDiscountPercentage = typeof discountPercentage === 'string' ? discountPercentage : `-${discountPercentage}%`;
    const shouldRenderMarker = discountPercentage || showPriceMarker || promotionalMarkerText;
    if (!shouldRenderMarker)
        return null;
    return (React.createElement("div", { className: cn(discountPercentage ? styles.percentageMarker : styles.promotionMarker, legalText && styles.legalTextConatiner) },
        legalText && !discountPercentage && (React.createElement(MetaText, { Tag: "p", className: styles.toolTipText }, legalText)),
        React.createElement(BodyText, { Tag: "span" }, discountPercentage
            ? formatedDiscountPercentage
            : showPriceMarker
                ? redPrice
                : promotionalMarkerText)));
};
export default ProductPromotionMarker;
//# sourceMappingURL=ProductPromotionMarker.js.map